// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.CreateRenterAccountWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { CreateRenterAccountWebApiHandler_createRenterAccount } from '@zg-rentals/ts-rent-payment-client';

import type { CreateRenterAccountWebApiRequestDto } from '@zg-rentals/ts-rent-payment-client';

export interface CreateRenterAccountWebApiHandler_createRenterAccount_Args {
  postData: CreateRenterAccountWebApiRequestDto;
}

export type CreateRenterAccountWebApiHandler_createRenterAccount_Options = UseMutationOptions<
  void,
  unknown,
  CreateRenterAccountWebApiHandler_createRenterAccount_Args
>;

/**
 * create a renter account
 */
export const useCreateRenterAccountWebApiHandler_createRenterAccount = ({
  httpClient,
  ...options
}: Omit<CreateRenterAccountWebApiHandler_createRenterAccount_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CreateRenterAccountWebApiHandler_createRenterAccount_Args) =>
      CreateRenterAccountWebApiHandler_createRenterAccount(args.postData, httpClient),
  });
};
